import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import * as fromStaff from './staff.reducer';
import { StaffEffects } from './staff.effects';
import { StaffFacade } from './staff.facade';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(
      fromStaff.STAFF_FEATURE_KEY,
      fromStaff.reducer
    ),
    EffectsModule.forFeature([StaffEffects]),
  ],
  providers: [StaffFacade],
})
export class StaffStateModule {}
